import { c as _c } from "react/compiler-runtime";
import { cn } from '@morpho-org/ui-v6/utils';
import { Icon } from '@repo/ui';
import { Alert } from '@repo/ui/icons';
import { memo } from 'react';
import type { TimelockCriticality } from '../utils';
import { StyledVaultPendingTimelock } from '../VaultV2PendingTimelockStyled';
interface VaultPendingTimelockHeaderProps extends React.PropsWithChildren {
  title: string;
  criticality?: TimelockCriticality;
}
const VaultPendingTimelockHeader = t0 => {
  const $ = _c(15);
  const {
    title,
    children,
    criticality
  } = t0;
  const iconColorClass = criticality === "high" ? "text-destructive-foreground" : undefined;
  const textColorClass = criticality === "high" ? "text-destructive-foreground" : "text-foreground";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Alert />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== iconColorClass) {
    t2 = <Icon icon={t1} className={iconColorClass} />;
    $[1] = iconColorClass;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== textColorClass) {
    t3 = cn("text-sm", textColorClass);
    $[3] = textColorClass;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      whiteSpace: "nowrap"
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== title) {
    t5 = <span className={t3} style={t4}>{title}</span>;
    $[6] = t3;
    $[7] = title;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t5) {
    t6 = <div className="gap-2xs flex flex-row items-center">{t2}{t5}</div>;
    $[9] = t2;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== children || $[13] !== t6) {
    t7 = <StyledVaultPendingTimelock.Header>{t6}{children}</StyledVaultPendingTimelock.Header>;
    $[12] = children;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
export default memo(VaultPendingTimelockHeader);